export const TRACK_ADDED = 'TRACK_ADDED';
export const TRACK_CREATE_CANCELED = 'TRACK_CREATE_CANCELED';
export const TRACK_CREATE_ERROR = 'TRACK_CREATE_ERROR';
export const TRACK_NO_DATA_FROM_SOURCE = 'TRACK_NO_DATA_FROM_SOURCE';
export const TRACK_REMOVED = 'TRACK_REMOVED';
export const TRACK_UPDATED = 'TRACK_UPDATED';
export const TRACK_WILL_CREATE = 'TRACK_WILL_CREATE';
export const TRACK_STOPPED = "TRACK_STOPPED";
// export const TRACK_PARTICIPANT_UPDATE = "TRACK_PARTICIPANT_UPDATE";